<script>
import { getOfficialGroups, joinOfficialGroups } from '../api/groups';
import { setUserProfile } from '../api/users';

export default {
    components: {
        CpButton: require('../button').default,
        CpButtonLink: require('../button-link').default,
        CpDialog: require('../dialog').default,
        CpBoxContent: require('../box-content').default,
        CpBox: require('../box').default,
        CpTextInput: require('../inputs/text').default,
        VueSimpleSpinner: require('../vue-simple-spinner').default,
        CpBaseSvgIcon: require('../base-svg-icon').default,
        SuggestionCompleteIcon: require('../social-feed/icons/suggestion-complete').default,
    },
    directives: {
        margin: require('../directives/margins').margin,
        marginBottom: require('../directives/margins').marginBottom,
        marginTop: require('../directives/margins').marginTop,
    },
    props: {
        handleJoinGroupDialog: Function,
        setCurrentJoinedOfficialGroups: Function,
    },
    name: 'CpJoinGroupDialog',
    data() {
        return {
            groups: [],
            loadingGroups: true,
            loadingJoin: false,
            joinSuccess: false,
            joinError: false,
            mutableList: [],
            emptyGroups: false,
            loadingClose: false,
        };
    },
    mounted() {
        getOfficialGroups()
            .then((response) => {
                if (response.length == 0) {
                    this.emptyGroups = true;
                    this.loadingGroups = false;
                } else {
                   this.groups = response;
                   this.mutableList = JSON.parse(JSON.stringify(this.groups));
                   this.loadingGroups = false;
                }
            })
            .catch((error) => {
                this.loadingGroups = false;
                console.warn(error);
            });
    },
    methods: {
        handleGroup(group, event) {
            if (event.target.checked) {
                this.mutableList.push(group);
            } else if (!event.target.checked) {
                for(var i = 0; i < this.mutableList.length; i++) {
                    if(this.mutableList[i].id == group.id) {
                        this.mutableList.splice(i, 1);
                        break;
                    }
                }
            }
        },
        joinGroups() {
            if (!this.authUser) {
                window.location.href = '/user/login';
            } else if (this.mutableList.length == 0) {
                this.setCurrentJoinedOfficialGroups(true);
            } else {
                this.loadingJoin = true;
                joinOfficialGroups({ groups: this.mutableList })
                    .then((response) => {
                        this.setCurrentJoinedOfficialGroups(false);
                        this.loadingJoin = false;
                        this.joinSuccess = true;
                    })
                    .catch((error) => {
                        this.loadingJoin = false;
                        this.joinError = true;
                        console.warn(error);
                    });
            }
        },
        closeEmptyGroups() {
            this.loadingClose = true;
            this.setCurrentJoinedOfficialGroups(true);
        }
    },
    computed: {
        authUser() {
            return this.$root.authUser;
        },
    },
};
</script>
<template>
    <cp-dialog>
        <cp-box>
            <cp-box-content>
                <section style="margin: 2em 2em; max-width: 40ch">
                    <template v-if="!joinSuccess && !joinError" class="share-container">
                        <h2 class="title-groups">You will be automatically added to the following groups</h2>
                        <h4 class="subtitle-groups">Uncheck the groups that are not of interest to you.</h4>
                        <div v-if="loadingGroups" class="heading-4" style="text-align: center">
                            <vue-simple-spinner v-margin="1" />Loading...
                        </div>
                        <div v-else-if="!loadingGroups && emptyGroups">
                            <h2 class="title-empty">Congratulations! You have joined all our official groups recommended for you.</h2>
                            <div style="text-align: center; margin: 10px 0">
                                <cp-base-svg-icon
                                    :width="150"
                                    :height="150"
                                    :viewBox="'0 0 201 201'"
                                    :icon-color="'currentColor'"
                                    :stroke-color="'none'"
                                    style="vertical-align: middle"
                                >
                                    <suggestion-complete-icon />
                                </cp-base-svg-icon>
                            </div>
                            <div style="text-align: right; margin-top: 10px;">
                                <cp-button @click="closeEmptyGroups()" primary :loading="loadingClose" :disabled="loadingClose" style="width: 30%;">CLOSE</cp-button>
                            </div>
                        </div>
                        <div v-if="groups.length">
                            <div v-for="group in groups" class="box-groups">
                                <input type="checkbox" :id="group.id" :value="group" v-model="mutableList" @click="handleGroup(group, $event)">
                                <h5 class="group-title">{{ group.title }}</h5>
                            </div>
                            <div style="text-align: right;">
                                <cp-button @click="joinGroups()" primary :loading="loadingJoin" :disabled="loadingGroups ||loadingJoin" style="width: 30%;">JOIN</cp-button>
                            </div>
                        </div>
                    </template>
                    <template v-else-if="joinSuccess">
                        <svg
                            @click.prevent="handleJoinGroupDialog(false)"
                            class="close-svg-icon"
                            stroke="currentColor"
                            fill="currentColor"
                            stroke-width="0"
                            viewBox="0 0 512 512"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M278.6 256l68.2-68.2c6.2-6.2 6.2-16.4 0-22.6-6.2-6.2-16.4-6.2-22.6 0L256 233.4l-68.2-68.2c-6.2-6.2-16.4-6.2-22.6 0-3.1 3.1-4.7 7.2-4.7 11.3 0 4.1 1.6 8.2 4.7 11.3l68.2 68.2-68.2 68.2c-3.1 3.1-4.7 7.2-4.7 11.3 0 4.1 1.6 8.2 4.7 11.3 6.2 6.2 16.4 6.2 22.6 0l68.2-68.2 68.2 68.2c6.2 6.2 16.4 6.2 22.6 0 6.2-6.2 6.2-16.4 0-22.6L278.6 256z"
                            ></path>
                        </svg>
                        <div style="display: flex; justify-content: center">
                            <i class="fas fa-check share-icon"></i>
                        </div>
                        <p class="heading-4">Has successfully joined the groups!</p>
                    </template>
                    <template v-else-if="joinError">
                        <svg
                            @click.prevent="handleJoinGroupDialog(false)"
                            class="close-svg-icon"
                            stroke="currentColor"
                            fill="currentColor"
                            stroke-width="0"
                            viewBox="0 0 512 512"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M278.6 256l68.2-68.2c6.2-6.2 6.2-16.4 0-22.6-6.2-6.2-16.4-6.2-22.6 0L256 233.4l-68.2-68.2c-6.2-6.2-16.4-6.2-22.6 0-3.1 3.1-4.7 7.2-4.7 11.3 0 4.1 1.6 8.2 4.7 11.3l68.2 68.2-68.2 68.2c-3.1 3.1-4.7 7.2-4.7 11.3 0 4.1 1.6 8.2 4.7 11.3 6.2 6.2 16.4 6.2 22.6 0l68.2-68.2 68.2 68.2c6.2 6.2 16.4 6.2 22.6 0 6.2-6.2 6.2-16.4 0-22.6L278.6 256z"
                            ></path>
                        </svg>
                        <div style="display: flex; justify-content: center">
                            <i class="fas fa-times error-icon"></i>
                        </div>
                        <p class="heading-4" style="text-align: center">An error has occurred!</p>
                    </template>
                </section>
            </cp-box-content>
        </cp-box>
    </cp-dialog>
</template>
<style scoped>
.title-empty {
    font-size: 16px;
}
.group-title {
    margin: 5px;
    font-size: 14px;
}
.box-groups {
    display: flex;
    align-items: center;
}
.heading-4 {
    color: #ff4814 !important;
}
.subtitle-groups {
    font-style: italic;
    color: #555555;
    font-size: 14px;
    opacity: 70%;
    margin-top: 5px;
}
.close-svg-icon {
    cursor: pointer;
}
.heading-4 {
    text-align: center;
    color: #000000;
}
.btn-modal {
    width: 50%;
    margin: 10px;
}
.title-groups {
    font-size: 20px;
    margin: 20px auto 0;
    color: #ED572F;
}
.btn-cancel {
    background: #f53c3c;
    border-radius: 5px;
    color: #fff;
}
.btn-confirm {
    background: #22bb69;
    border-radius: 5px;
    color: #fff;
}
.share-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    max-width: 1000px;
    margin: auto;
}
.share-icon {
    font-size: 3em;
    color: var(--success);
}
.error-icon {
    font-size: 3em;
    color: red;
}
</style>
